import { render, staticRenderFns } from "./ActiveProduct.vue?vue&type=template&id=7140ecbc&"
import script from "./ActiveProduct.vue?vue&type=script&lang=js&"
export * from "./ActiveProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports